export function getStartPageUrl(language) {
  switch (language) {
    case 'sv':
      return 'https://join.lifesum.com/zc/1435'
    case 'de':
      return 'https://join.lifesum.com/f/1067/starting'
    case 'no':
      return 'https://join.lifesum.com/f/1034/starting'
    case 'da':
      return 'https://join.lifesum.com/f/1036/starting'
    case 'en':
    default:
      return 'https://join.lifesum.com/f/1063/starting'
  }
}
